import { useEffect } from 'react';

/**
 * Cross-fades the page canvas between two dark tones as sections pass the
 * middle of the viewport. Sections opt in with `data-tone="deep"`; anything
 * else counts as the default void. The fade itself is CSS (`@property
 * --page-bg` + a transition on :root in index.css), this only flips
 * `data-tone` on <html>.
 */
export default function useSectionTone(deps = []) {
  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const root = document.documentElement;
    const sections = document.querySelectorAll('[data-tone]');
    if (!sections.length) return undefined;

    // A thin band at the viewport centre: whichever section crosses it wins.
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) root.dataset.tone = e.target.dataset.tone;
        });
      },
      { rootMargin: '-50% 0px -50% 0px' }
    );
    sections.forEach((s) => io.observe(s));

    // Plain sections between tinted ones must reset the tone too.
    const plain = document.querySelectorAll('[data-tone-base]');
    const ioBase = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) root.dataset.tone = 'base';
        });
      },
      { rootMargin: '-50% 0px -50% 0px' }
    );
    plain.forEach((s) => ioBase.observe(s));

    return () => {
      io.disconnect();
      ioBase.disconnect();
      delete root.dataset.tone;
    };
  }, deps); // eslint-disable-line
}
